import types from '../constants/CourseSectionActionTypes';
import {
  createItemFail,
  createItemSuccess,
  removeItemFail,
  removeItemSuccess,
  updateItemFail,
  updateItemSuccess,
} from './utils';

const initialState = {
  status: { fetch: {} },
  items: {},
};

export default function courseSections(state = initialState, action) {
  switch (action.type) {
    case types.CREATE_COURSE_SECTION_SUCCESS:
      return createItemSuccess(state, action);
    case types.CREATE_COURSE_SECTION_FAIL:
      return createItemFail(state, action);

    case types.UPDATE_COURSE_SECTION_SUCCESS:
      return updateItemSuccess(state, action);
    case types.UPDATE_COURSE_SECTION_FAIL:
      return updateItemFail(state, action);

    case types.DELETE_COURSE_SECTION_SUCCESS:
      return removeItemSuccess(state, action);
    case types.DELETE_COURSE_SECTION_FAIL:
      return removeItemFail(state, action);

    default:
      return state;
  }
}
